import React from "react";
import { Col, Row } from "react-bootstrap";
import AddCircle from "@material-ui/icons/AddCircle";

const RecurrenceComponent = ({
  title,
  cleanRecurring,
  setShowUpdateRecurringButton,
  setShowRecurring,
  onlyReviewWithComments,
}) => {
  return (
    <Row>
      <Col
        md="8"
        className="d-flex justify-content-center align-items-center font-w-600"
      >
        {title}
      </Col>
      <Col md="4">
        <AddCircle
          style={{
            opacity: onlyReviewWithComments ? "0.4" : "1",
            cursor: "pointer",
          }}
          onClick={() => {
            if (!onlyReviewWithComments) {
              cleanRecurring();
              setShowUpdateRecurringButton(false);
              setShowRecurring(true);
            }
          }}
        ></AddCircle>
      </Col>
    </Row>
  );
};

export default RecurrenceComponent;
